<h1 inline-edit="stencilData.properties.value?.value">{{ payload.properties.value.value }}</h1>
